<template lang="en">
  <!-- where to we want to do this guard-->
  <div v-if="total" @click.stop.prevent="$store.dispatch('payapAction', true)" class="centrapay"> 
    <div class="centrapay_center">
      <img src="/centrapay_logo_orange.svg" />
      <button class="payap" >PAYA<span class="flip">P</span></button>
    </div>
  </div>
<!-- if the qr is trying to show but it hasnt been paid yet -->
	<div v-if="payapQrcodeShow" class="centrapay_right" >
    <font-awesome-icon icon="xmark" @click.stop.prevent="cancelPayment" class="icon" size="xl"/>
    <qr-code id="qr"
        :contents= payURL
        position-ring-color="var(--text-colour)"
        position-center-color="var(--centrapay-orange)"
        module-color="var(--text-colour)">
        <!-- eslint-disable-next-line -->
      <img v-if="payapQrcodeShow" id="qr-img" src="/centrapay_symbol_orange.svg" slot="icon"/>
    </qr-code>
	</div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "CentrapayQRCode",
  props: {
    channel: {
      type: Object,
      required: true,
    },
    lineItems: {
      type: Array,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
  },
  emits: ["complete"],

  data() {
    return {
      centrapay: "",
      payapQrcodeShow: false,
      payURL: "https://beammeup.nz",
      //channel: null,
      replyID: "",
      paid: false,
    };
  },

  //created() {
  //  this.channel = this.$.appContext.config.globalProperties.channel;
  //},

  computed: {
    ...mapGetters({ 
      getPayapVoided: "getPayapVoided", 
      getPayap: "getPayap", 
      getPayapTimeout: "getPayapTimeout", 
      getPayapCancel: "getPayapCancel", 
      getPayapPaid: "getPayapPaid",
     }),
  },

  methods: {
    async payapRequest() {
      const lineitems_amount = this.lineItems.map((line) => parseInt(line.price));
      const basket = lineitems_amount.reduce((acc, item) => acc + item, 0);

      this.channel.push("centrapay:payment", { value: (this.total * 100).toString(), lineItems: this.lineItems, lineItemsAmount: basket.toString()})
      .receive("ok", (reply) => {
        this.payURL = reply["url"];
        this.payapQrcodeShow = true;
        this.$store.dispatch("payapAction", true);
        this.$store.dispatch("payapPaidAction", false);
        this.replyID = reply["id"];
        console.log("payap request");
      });
    },

    cancelPayment() {
      this.channel.push("centrapay:void_payment", { id: this.replyID })
      .receive("ok", () => {
        this.$store.dispatch("payapVoidedAction", true);
        this.$store.dispatch("payapAction", false);
        this.$store.dispatch("payapPaidAction", false);
      });
    },

  },
  watch: {
    getPayapTimeout: {
      handler: function () {
        if (this.getPayapTimeout) {
          this.payapQrcodeShow = false;
        }
      },
    },
    getPayap: {
      handler: function () {
        if (this.getPayap) { //if there is a payap payment but it is not paid
          console.log("watch on the getPayap");
          this.payapRequest();
        } else {
          this.payapQrcodeShow = false;
        }
      },
    },
    getPayapCancel: {
      handler: function () {
        if (this.getPayapCancel) {
          this.payapQrcodeShow = false;
          this.$store.dispatch("payapCancelAction", false);
        }
      },
    },
    getPayapPaid: { //on the change of paid 
      handler: function () {
        if (this.getPayapPaid) { //if it has been paid
          console.log("watch on the getPayapPaid");
          this.$emit("complete", true); //and emit to the parent to display the reciept
        }
      },
    },
  },
};
</script>

<style scoped lang="scss">
.centrapay_right {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 100%;
  background-color: var(--primary-colour);
  position: absolute;
  z-index: 1000;
  top: 0;
  left: 0;
  margin: 0;

  h1 {
    margin: 1rem auto;
    background-color: var(--text-colour);
    width: 3rem;
    height: 3rem;
    border-radius: 50%;
    color: var(--centrapay-orange);
    // text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 0 0.5rem rgba(0, 0, 0, 0.3);
  }

  #qr-img {
    width: 100%;
    display: flex;
    padding: 0;
  }

  #qr {
    width: 50%;
    background-color: var(--primary-colour);
  }
}

.centrapay_center {
  margin: 1rem 0.5rem auto;
  padding: 1rem 0.5rem;
  width: 60%;
  max-width: 30vw;

  .payap {
    background-color: var(--primary-colour);
    color: var(--text-colour);
    box-shadow: var(--box-shadow);
    border: none;
    margin-top: 0.5rem;
    .flip {
      display: inline-block;
      transform: scale(-1, 1);
    }
  }
}

.centrapay {
  display: flex;
  justify-content: center;
  width: 90%;
  margin: 1rem auto;
  // border: 1px solid var(--text-colour);
  box-shadow: var(--box-shadow);
  border-radius: 10px;
  background-color: var(--secondary-colour);
}

// .centrapay {
// width: 90%;
// left: 5%;
// border: 1px solid  var(--text-colour);
// border-radius: 0.5rem;
// position: absolute;
// bottom: 25px;
// height: 20vh;
// cursor: pointer;
// div.left {
// 		transform: translateX(-25vw);
// 		button {
// 				bottom: -2rem;
// 		}
// }
// div.right {
// 		transform: translateY(-10rem);
// 		float: right;
// 		width: 29rem;
// }

// div {
// 		img {
// 				padding: 2rem;
// 				width: 40%;
// 				margin: auto;
// 		}
// 		.payap {
// 				display: flex;
// 				width: 10%;
// 				margin: auto;
// 				color: #000;
// 				background: #fff;
// 				font-size: 1rem;
// 				position: absolute;
// 				bottom: 1rem;
// 				left: 35%;
// 				.flip {
// 						display: inline-block;
// 						transform: scale(-1, 1);
// 				}
// 		}
// }
// }
</style>
